import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client';
import type { DocumentCountsSummaryResponse } from '@schemas/api';
import { useAuthStore } from '@store/authStore';

const useTenantQueryScope = () => useAuthStore((state) => state.activeTenantId ?? state.currentUser?.active_tenant_id ?? 'no-tenant');

export const useDocumentStats = () => {
  const tenantScope = useTenantQueryScope();

  const summary = useQuery({
    queryKey: ['stats', tenantScope, 'document-summary'],
    queryFn: async () => {
      const { data } = await apiClient.get<DocumentCountsSummaryResponse>('/counts/summary');
      return data;
    },
    refetchInterval: 30000,
  });

  const result = {
    poCount: summary.data?.purchase_orders ?? 0,
    receiptCount: summary.data?.receipts ?? 0,
    invoiceCount: summary.data?.invoices ?? 0,
    totalDocuments: summary.data?.total_documents ?? 0,
    pendingReviewCount: summary.data?.pending_review_count ?? 0,
    poPendingReview: summary.data?.po_pending_review ?? 0,
    receiptPendingReview: summary.data?.receipt_pending_review ?? 0,
    invoicePendingReview: summary.data?.invoice_pending_review ?? 0,
    isLoading: summary.isLoading,
    isError: summary.isError,
  };
  return result;
};
